import type {
  CreateSiteInput,
  SiteDetail,
  SiteFormOptions,
  SiteSummary,
  UpdateSiteInput,
} from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchSites(params?: {
  page?: number;
  pageSize?: number;
  status?: string;
  includeArchived?: boolean;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.status) search.set("status", params.status);
  if (params?.includeArchived) search.set("includeArchived", "true");

  const qs = search.toString();
  return apiFetch<{ data: SiteSummary[]; meta: { total?: number; page: number; pageSize: number } }>(
    `/api/sites${qs ? `?${qs}` : ""}`,
  );
}

export async function fetchSiteOptions() {
  return apiFetch<{ data: SiteFormOptions }>("/api/sites/options");
}

export async function fetchSite(siteId: string) {
  return apiFetch<{ data: SiteDetail }>(`/api/sites/${siteId}`);
}

export async function createSite(input: CreateSiteInput) {
  return apiFetch<{ data: SiteDetail }>("/api/sites", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateSite(siteId: string, input: UpdateSiteInput) {
  return apiFetch<{ data: SiteDetail }>(`/api/sites/${siteId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export async function archiveSite(siteId: string, reason?: string) {
  return apiFetch<{ data: SiteDetail }>(`/api/sites/${siteId}/archive`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}
